var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBush1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 12 12",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#a9e032",
    d: "M5 3h3M3 4h3m1 0h2M2 5h4m1 0h3M1 6h2m4 0h1m1 0h2M1 7h1m5 0h1m2 0h1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#b51800",
    d: "M6 4h1M4 6h1m3 0h1M2 7h1m3 1h1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#14aa44",
    d: "M6 5h1M4 7h1m3 0h1M2 8h1m3 1h1m2 0h2m-9 1h1m1 0h1m2 0h3m-7 1h6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#70cb1c",
    d: "M3 6h1m1 0h2M3 7h1m1 0h2m2 0h1M1 8h1m1 0h3m1 0h4M1 9h5m1 0h2m-6 1h1m1 0h2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBush1);
export default __webpack_public_path__ + "static/media/bush1.bc2205cdb9837c064a99a7391074e15c.svg";
export { ForwardRef as ReactComponent };